import {
  EMPLOYEE_PAYROLL,
  PAYROLL,
  PAYROLL_BANK_CONFIG,
  PAYROLL_RUNS,
  PAYROLL_RUN_DETAIL,
  TAX_CONFIG,
  PROVIDENT_FUND,
  GRATUITY_FUND,
  ATTENDANCE_PAY,
  AMOUNT_ROUNDING,
  PAYROLL_ELM,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

export const PayrollRoutes: IAppRoutes = {
  link: PAYROLL,
  childrens: [
    {
      // Salary structure building blocks (earning/deduction elements).
      link: PAYROLL_ELM,
      element: guard(() => import('@modules/settings/payroll-elm'), [PAYROLL_ELM]),
    },
    {
      link: EMPLOYEE_PAYROLL,
      element: guard(() => import('@modules/payroll/emp-payroll'), [EMPLOYEE_PAYROLL]),
    },
    {
      link: PAYROLL_RUNS,
      element: guard(() => import('@modules/payroll/payroll-run'), [PAYROLL_RUNS]),
    },
    {
      link: PAYROLL_RUN_DETAIL({id: ':id'}),
      element: guard(() => import('@modules/payroll/run-detail'), [PAYROLL_RUNS]),
    },
    {
      // Company disbursement account + signatory for the salary bank advice.
      link: PAYROLL_BANK_CONFIG,
      element: guard(() => import('@modules/payroll/bank-config'), [PAYROLL_BANK_CONFIG]),
    },
    {
      // BD statutory income-tax configuration per tax year.
      link: TAX_CONFIG,
      element: guard(() => import('@modules/payroll/tax-config'), [TAX_CONFIG]),
    },
    {
      // Provident Fund policy (employee % of Basic + optional employer match).
      link: PROVIDENT_FUND,
      element: guard(() => import('@modules/payroll/provident-fund'), [PROVIDENT_FUND]),
    },
    {
      // Gratuity Fund policy — consumed by the separation final-settlement.
      link: GRATUITY_FUND,
      element: guard(() => import('@modules/payroll/gratuity-fund'), [GRATUITY_FUND]),
    },
    {
      // Attendance → pay coupling policy (deduct absent / unpaid-leave days).
      link: ATTENDANCE_PAY,
      element: guard(() => import('@modules/payroll/attendance-pay'), [ATTENDANCE_PAY]),
    },
    {
      // Per-company net-pay amount rounding.
      link: AMOUNT_ROUNDING,
      element: guard(() => import('@modules/payroll/amount-rounding'), [AMOUNT_ROUNDING]),
    },
  ],
}
